import Fab from './Fab';

/**
 * The legacy "New +" floating action button parked at the bottom-right of the list pages above
 * the bottom navigation. `bottom` is the per-page offset (100px on the Equipment and Calibration
 * Due Dates lists, ...).
 */
const NewFab = ({
  onClick,
  bottom = 100,
  label = 'New',
}: {
  onClick: () => void;
  bottom?: number;
  label?: string;
}) => <Fab label={label} bottom={bottom} onClick={onClick} />;

export default NewFab;
